import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'iisral_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      const timer = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 animate-fade-up"
      role="dialog"
      aria-label="Küpsiste nõusolek"
    >
      <div className="bg-[#1A3828] border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          {/* Text */}
          <div className="flex items-start gap-3 flex-1 min-w-0">
            <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
              <i className="ri-cookie-line text-eco-green text-base" />
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              See veebileht kasutab küpsiseid parema kasutuskogemuse tagamiseks.{' '}
              <Link
                to="/kupsiste-poliitika"
                className="text-eco-green hover:underline font-medium whitespace-nowrap"
              >
                Loe lähemalt
              </Link>
            </p>
          </div>

          {/* Buttons */}
          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={handleDecline}
              className="text-white/50 hover:text-white text-sm font-medium px-4 py-2 rounded-full border border-white/20 hover:border-white/40 transition-colors cursor-pointer whitespace-nowrap"
            >
              Keeldun
            </button>
            <button
              onClick={handleAccept}
              className="bg-eco-green text-white text-sm font-bold px-5 py-2 rounded-full cursor-pointer whitespace-nowrap hover:bg-dark-green transition-colors"
            >
              Nõustun
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
